/**
 * YouTube Video Gallery — product-details block
 * Handles: thumbnail click → main player swap, img fallback for missing maxresdefault
 */
(function () {
  function initGallery(gallery) {
    var mainEl = gallery.querySelector('.product-yt-gallery__main');
    var thumbs = gallery.querySelectorAll('.product-yt-gallery__thumb');
    if (!mainEl) return;

    // Img fallback: maxresdefault → hqdefault (avoids onerror inline attrs)
    gallery.querySelectorAll('img[data-fallback]').forEach(function (img) {
      img.addEventListener('error', function () {
        if (this.src !== this.dataset.fallback) {
          this.src = this.dataset.fallback;
        }
      }, { once: true });
    });

    function loadVideo(id, title) {
      mainEl.style.visibility = 'hidden';
      mainEl.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?rel=0&modestbranding=1&autoplay=1';
      iframe.title = title || 'YouTube video';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';
      iframe.addEventListener('load', function () { mainEl.style.visibility = ''; });
      mainEl.appendChild(iframe);
      mainEl.style.visibility = '';
    }

    // Autoplay: activate first video via IntersectionObserver when gallery enters viewport
    var autoplayIframe = mainEl.querySelector('iframe[data-src]');
    if (autoplayIframe) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            autoplayIframe.src = autoplayIframe.dataset.src;
            obs.disconnect();
          }
        });
      }, { threshold: 0.25 });
      obs.observe(gallery);
      // No main-player click handler needed in autoplay mode — fall through to attach thumb handlers
    } else {
      // Click-to-play mode: clicking the poster loads the video
      mainEl.addEventListener('click', function () {
        var active = gallery.querySelector('.product-yt-gallery__thumb.is-active');
        var id = active ? active.dataset.videoId : mainEl.dataset.videoId;
        var title = active ? active.dataset.title : mainEl.dataset.title;
        if (id) loadVideo(id, title);
      });
    }

    // Thumbnail clicks — work in both autoplay and click-to-play mode
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');
        loadVideo(this.dataset.videoId, this.dataset.title);
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-yt-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
